import { CustomLink } from '@/components/custom-link/CustomLink';
import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { AppTheme } from '@/shared/constant/AppTheme';
import { isClient } from '@/shared/util/ssr';
import clsx from 'clsx';
import React from 'react';

export type BrandProps = {
  className?: string;
};

export function Brand(props: BrandProps) {
  const { className } = props;

  const getDocsDataModelStoreState = useDocsDataModelStore((x) => x.getState);
  const getAppearanceConfigModelStoreState = useAppearanceConfigModelStore((x) => x.getState);
  const title = useDocsDataModelStore((x) => x.docsBaseConfig.title);
  const homeLink = useDocsDataModelStore((x) => x.sidebarTree.homeLink);

  const logo = React.useMemo(() => {
    const logoSettings = getDocsDataModelStoreState().docsBaseConfig.logoSettings;
    const theme = getDocsDataModelStoreState().docsBaseConfig.theme;
    const appTheme = getAppearanceConfigModelStoreState().appTheme;

    return logoSettings[
      isClient
        ? window.__currentTheme
        : (appTheme ??
          (() => {
            if (theme !== AppTheme.System) {
              return theme;
            }

            return AppTheme.Light;
          })())
    ];
  }, [getAppearanceConfigModelStoreState, getDocsDataModelStoreState]);

  return (
    <CustomLink to={homeLink} className={clsx('flex items-center truncate', className)}>
      <div className="mr-3 flex-shrink-0">
        <img
          className="_brand-logo h-7 min-w-7 rounded-lg object-cover"
          src={logo}
          suppressHydrationWarning
          alt=""
        />
      </div>

      <b className="truncate text-paragraph font-600 text-color hover:text-primary">{title}</b>
    </CustomLink>
  );
}
